require('./angular');
module.exports = angular;


/*** EXPORTS FROM exports-loader ***/
module.exports = window.angular;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular/index.js
// module id = 0
// module chunks = 6